<template>
  <div>
    <!-- Botão da Análise de Medicamentos -->
    <div class="dropdown d-inline-block ai-chat-dropdown enhanced-ai-chat">
      <button
        type="button"
        class="enhanced-ai-btn"
        :class="{ loading: loading }"
        @click="execute"
        :disabled="loading"
      >
        <span v-if="!loading" class="mr-2">Analisar</span>
        <span v-if="loading" class="mr-2">Analisando...</span>
        <img
          v-if="!loading"
          :src="require('../../assets/sistemaclinai.webp')"
          class="sistemaclin-ai"
          alt="SistemaClin AI"
        />
      </button>
    </div>

    <b-modal
      id="AIMedicineAnalyzer"
      hide-footer
      hide-header
      no-close-on-backdrop
      scrollable
      size="xl"
    >
      <div>
        <!-- Loading State -->
        <div v-if="loading" class="loading-container">
          <div class="loading-content">
            <div class="loading-animation">
              <img
                :src="require('../../assets/sistemaclinai.webp')"
                class="loading-ai-icon"
                alt="SistemaClin AI"
              />
              <div class="loading-dots">
                <span></span>
                <span></span>
                <span></span>
              </div>
            </div>
            <h4>Analisando Padrão de Medicamentos...</h4>
            <p>Processando dados terapêuticos e identificando padrões</p>
          </div>
        </div>

        <!-- Conteúdo da Análise -->
        <div v-if="!loading && analysisResult" class="analysis-content">
          <div
            class="message-text"
            v-html="formatAIResponse(analysisResult)"
          ></div>
        </div>

        <!-- Estado de Erro -->
        <div v-if="!loading && errorMessage" class="error-content">
          <div class="error-icon">
            <i class="fas fa-exclamation-triangle"></i>
          </div>
          <h4>Erro na Análise</h4>
          <p>{{ errorMessage }}</p>
          <button class="btn-retry" @click="execute">
            <i class="fas fa-redo mr-2"></i>
            Tentar Novamente
          </button>
        </div>

        <!-- Footer do Modal -->
        <div v-if="!loading" class="analysis-footer">
          <div class="footer-info">
            <small>
              <i class="fas fa-clock"></i>
              Análise realizada em {{ analysisTime }}
            </small>
          </div>
          <div class="footer-actions">
            <button
              class="btn-modern btn-modern-info"
              @click="execute"
              :disabled="loading"
            >
              <i class="fas fa-redo mr-1"></i>
              Atualizar análise
            </button>
            <button class="btn-modern btn-modern-save" @click="closeModal">
              <i class="fas fa-check mr-1"></i>
              Concluir
            </button>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import api from "../../services/api";
import moment from "moment";

export default {
  name: "AIMedicineAnalyzer",

  data() {
    return {
      loading: false,
      analysisResult: null,
      errorMessage: null,
      analysisTime: null,
    };
  },

  methods: {
    async execute() {
      try {
        this.$bvModal.show("AIMedicineAnalyzer");

        this.loading = true;
        this.errorMessage = null;
        this.analysisResult = null;

        const responseAi = await api.get("/ai/medicine/analyzer");

        if (responseAi.data.error) {
          this.errorMessage =
            responseAi.data.response || "Erro desconhecido na análise";
        } else {
          this.analysisResult = responseAi.data.response;
          this.analysisTime = moment().format("DD/MM/YYYY HH:mm");
        }
      } catch (error) {
        console.error("Erro na chamada da API:", error);
        this.errorMessage =
          "Erro ao conectar com a IA. Verifique sua conexão e tente novamente.";
      } finally {
        this.loading = false;
      }
    },

    closeModal() {
      this.$bvModal.hide("AIMedicineAnalyzer");
      this.analysisResult = null;
      this.errorMessage = null;
    },

    formatAIResponse(text) {
      if (!text) return "";

      // Converte markdown básico para HTML
      let formattedText = text
        // Converte **texto** para <strong>texto</strong>
        .replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>")
        // Converte *texto* para <em>texto</em>
        .replace(/\*(.*?)\*/g, "<em>$1</em>")
        // Converte quebras de linha para <br>
        .replace(/\n/g, "<br>")
        // Converte listas numeradas
        .replace(/^(\d+\.\s+.*?)$/gm, '<div class="ai-numbered-item">$1</div>')
        // Converte listas com bullets (•   )
        .replace(/^•\s+(.+)$/gm, '<div class="ai-bullet-item">• $1</div>')
        // Converte sub-itens indentados
        .replace(/^(\s{4,})•\s+(.+)$/gm, '<div class="ai-sub-item">◦ $2</div>')
        // Converte títulos com ###
        .replace(/^###\s+(.+)$/gm, '<h4 class="ai-subtitle">$1</h4>')
        // Converte títulos com ##
        .replace(/^##\s+(.+)$/gm, '<h3 class="ai-title">$1</h3>');

      return formattedText;
    },
  },
};
</script>

<style scoped>
/* Botão Principal */
.enhanced-ai-chat {
  position: relative !important;
}

.enhanced-ai-btn {
  height: 42px !important;
  border-radius: 12px !important;
  background: #1f7fd3 !important;
  border: 2px solid rgba(255, 255, 255, 0.2) !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  text-decoration: none !important;
  cursor: pointer !important;
  transition: all 0.3s ease !important;
  position: relative !important;
  overflow: hidden !important;
  color: #fff;
  padding: 10px 16px;
  font-weight: 600;
}

.enhanced-ai-btn:hover {
  transform: scale(1.05) !important;
  color: white !important;
  text-decoration: none !important;
}

.enhanced-ai-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  transform: none !important;
}

.loading-spinner {
  width: 16px;
  height: 16px;
  border: 2px solid transparent;
  border-top: 2px solid white;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.sistemaclin-ai {
  width: 24px !important;
  height: 24px !important;
  object-fit: contain !important;
  transition: transform 0.2s ease !important;
}

.enhanced-ai-btn:hover .sistemaclin-ai {
  transform: rotate(15deg) !important;
}

/* Loading State */
.loading-container {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
}

.loading-content {
  text-align: center;
  max-width: 400px;
}

.loading-animation {
  margin-bottom: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.loading-ai-icon {
  width: 64px;
  height: 64px;
  animation: pulse 2s ease-in-out infinite;
}

@keyframes pulse {
  0%,
  100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.7;
    transform: scale(1.05);
  }
}

.loading-dots {
  display: flex;
  gap: 8px;
}

.loading-dots span {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #10b981;
  animation: bounce 1.4s infinite ease-in-out both;
}

.loading-dots span:nth-child(1) {
  animation-delay: -0.32s;
}
.loading-dots span:nth-child(2) {
  animation-delay: -0.16s;
}

@keyframes bounce {
  0%,
  80%,
  100% {
    transform: scale(0);
  }
  40% {
    transform: scale(1);
  }
}

.loading-content h4 {
  color: #1f2937;
  margin: 0 0 8px 0;
  font-size: 1.2rem;
}

.loading-content p {
  color: #6b7280;
  margin: 0;
}

/* Content */
.analysis-content {
  flex: 1;
  overflow-y: auto;
  padding: 24px;
  background: #f9fafb;
}

/* Error State */
.error-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;
}

.error-icon {
  width: 80px;
  height: 80px;
  background: #fef2f2;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
}

.error-icon i {
  font-size: 2rem;
  color: #dc2626;
}

.error-content h4 {
  color: #1f2937;
  margin: 0 0 12px 0;
  font-size: 1.3rem;
}

.error-content p {
  color: #6b7280;
  margin: 0 0 24px 0;
  max-width: 400px;
  line-height: 1.5;
}

.btn-retry {
  background: #dc2626;
  color: white;
  border: none;
  padding: 12px 20px;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.2s;
}

.btn-retry:hover {
  background: #b91c1c;
  transform: translateY(-1px);
}

/* Message Text Formatting */
.message-text {
  line-height: 1.6;
  color: #374151;
}

.message-text .ai-title {
  font-size: 1.4rem;
  font-weight: 700;
  color: #1f2937;
  margin: 20px 0 12px 0;
  border-bottom: 2px solid #10b981;
  padding-bottom: 8px;
}

.message-text .ai-subtitle {
  font-size: 1.1rem;
  font-weight: 600;
  color: #374151;
  margin: 16px 0 8px 0;
  display: flex;
  align-items: center;
  gap: 8px;
}

.message-text .ai-bullet-item {
  margin: 8px 0;
  padding-left: 16px;
  color: #4b5563;
}

.message-text .ai-numbered-item {
  margin: 10px 0;
  padding-left: 8px;
  font-weight: 600;
  color: #1f2937;
}

.message-text .ai-sub-item {
  margin: 6px 0;
  padding-left: 32px;
  color: #6b7280;
  font-size: 0.95rem;
}

/* Footer */
.analysis-footer {
  padding: 20px 24px;
  background: #f9fafb;
  border-top: 1px solid #e5e7eb;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
}

.footer-info small {
  color: #6b7280;
  display: flex;
  align-items: center;
  gap: 6px;
}

.footer-actions {
  display: flex;
  gap: 12px;
}

.btn-secondary {
  background: #f3f4f6;
  color: #374151;
  border: 1px solid #d1d5db;
  padding: 8px 16px;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.2s;
}

.btn-secondary:hover {
  background: #e5e7eb;
}

.btn-primary {
  background: #10b981;
  color: white;
  border: none;
  padding: 8px 20px;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.2s;
}

.btn-primary:hover {
  background: #059669;
}

/* Responsividade */
@media (max-width: 768px) {
  .ai-analysis-modal {
    padding: 10px;
  }

  .ai-analysis-content {
    max-height: 95vh;
    max-width: 100%;
  }

  .ai-analysis-header {
    padding: 16px;
  }

  .ai-analysis-header h3 {
    font-size: 1.2rem;
  }

  .header-info {
    gap: 12px;
  }

  .ai-logo {
    width: 40px;
    height: 40px;
  }

  .analysis-content {
    padding: 16px;
  }

  .analysis-footer {
    flex-direction: column;
    gap: 12px;
    text-align: center;
  }

  .footer-actions {
    width: 100%;
    justify-content: center;
  }
}

@media (max-width: 576px) {
  .ai-analysis-modal {
    padding: 5px;
  }

  .ai-analysis-content {
    border-radius: 8px;
  }

  .enhanced-ai-btn {
    height: 40px !important;
    padding: 8px 12px;
  }

  .enhanced-ai-btn span {
    font-size: 0.9rem;
  }

  .sistemaclin-ai {
    width: 20px !important;
    height: 20px !important;
  }
}

/* Scrollbar personalizada */
.analysis-content::-webkit-scrollbar {
  width: 6px;
}

.analysis-content::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 3px;
}

.analysis-content::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
}

.analysis-content::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}
</style>